import styled from '@emotion/styled'

export const StyledTermsBlock = styled.div`
  padding: 36px 0 12px;
`
